import { render, staticRenderFns } from "./MakeDeliveryplan.vue?vue&type=template&id=60574b8c&scoped=true"
import script from "./MakeDeliveryplan.vue?vue&type=script&lang=ts"
export * from "./MakeDeliveryplan.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60574b8c",
  null
  
)

export default component.exports